<template>
  <div id="mytable">
    <b-table
      :data="just_buildings"
      selectable
      :columns="columns"
      hoverable
      :selected.sync="selectedBuilding"
      :mobile-cards="false"
    >
      <template slot-scope="props">
        <b-table-column>
          <div v-if="props.row.dummy" class="dummy-row">
            <button
              @click="addBuildingClicked"
              class="button is-light"
              style="width: 100%"
              aria-label="Add new building"
            >
              <b-icon icon="plus" size="is-small"></b-icon>
              <span>Add new building</span>
            </button>
            <div v-if="just_buildings.length > 1" class="buildings-table-label">
              BUILDINGS
            </div>
            <div
              v-else
              class="buildings-table-label"
              style="text-align: center;"
            >
              Added buildings will appear in this list
            </div>
          </div>
          <div v-else>
            <div class>
              <span class="is-pulled-left">
                <span class="icon">
                  <i v-if="props.row.name == 'Remote'" class="fas fa-globe"></i>
                  <i v-else class="fas fa-building"></i>
                </span>
                <span>{{ props.row.name }}</span>
              </span>

              <span class="is-pulled-right item-three-dots">
                <b-dropdown
                  aria-role="list"
                  class="end"
                  position="is-bottom-left"
                >
                  <p
                    class="tag three-dots"
                    slot="trigger"
                    role="button"
                    aria-label="More options"
                  >
                    <span class="icon">
                      <i class="fas fa-ellipsis-h"></i>
                    </span>
                  </p>

                  <b-dropdown-item
                    id="delete-button"
                    aria-role="listitem"
                    is-danger
                    @click="deleteBuildingClicked(props.row)"
                    aria-label="Delete building"
                    class="dropdown-button"
                  >
                    <p class="is-vertical-center">
                      <b-icon icon="trash"></b-icon>Delete
                    </p>
                  </b-dropdown-item>
                  <b-dropdown-item
                    id="rename-button"
                    aria-role="listitem"
                    is-danger
                    @click="renameBuildingClicked(props.row)"
                    aria-label="Rename building"
                    class="dropdown-button"
                  >
                    <p class="is-vertical-center">
                      <b-icon icon="edit"></b-icon>Rename
                    </p>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
            </div>
          </div>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
// TODO: Add an empty element when there are no buildings
import { mapState } from "vuex";
import { Dialog } from "buefy/dist/components/dialog";
import { addBuilding, deleteBuilding, renameBuilding } from "../api-requests";

export default {
  name: "BuildingsTable",
  data() {
    return {
      columns: [
        {
          field: "name"
        }
      ]
    };
  },
  computed: {
    selectedBuilding: {
      get: function() {
        return this.$store.getters.selectedBuilding;
      },
      set: function(newValue) {
        console.log("Setting a new selected building");
        this.$store.commit("SET_SELECTED_BUILDING_ID", newValue.id);
      }
    },
    just_buildings: {
      get: function() {
        const just_buildings = this.$store.state.buildings;
        const copied = [...just_buildings];
        const sorted = copied.sort(function(a, b) {
          var nameA = a.name.toUpperCase(); // ignore upper and lowercase
          var nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
        return [{ dummy: true }, ...sorted];
      }
    }
  },
  watch: {
    selectedBuilding: function(newSelectedBuilding, oldSelectedBuilding) {
      // console.log(oldSelectedBuilding);
      // console.log(newSelectedBuilding);
      if (newSelectedBuilding.dummy === true) {
        this.selectedBuilding = oldSelectedBuilding;
      }
    }
  },
  methods: {
    addBuildingClicked: function() {
      console.log("Adding a building");
      var self = this; // To access "this" in closure.
      Dialog.prompt({
        // message: "Insert the building name",
        inputAttrs: {
          placeholder: "Name of new building",
          maxlength: 100
        },
        onConfirm: function(name) {
          console.log("Added a new building: " + name);
          addBuilding(name);
          // self.$store.commit("addBuilding", { name: name });
        },
        confirmText: "Add"
      });
    },
    deleteBuildingClicked: function(building) {
      console.log(building);
      Dialog.confirm({
        message:
          "Are you sure you want to <b>delete</b> " +
          building.name +
          "? This action cannot be undone.",
        type: "is-danger",
        hasIcon: true,
        icon: "exclamation-circle",
        iconPack: "fa",
        onConfirm: async function(value) {
          console.log("Deleted the building!");
          await deleteBuilding(building.id);
        },
        confirmText: "Delete"
      });
    },
    renameBuildingClicked: function(building) {
      console.log(building);
      Dialog.prompt({
        message: "Enter new name for this building.",
        inputAttrs: {
          placeholder: "New building name",
          maxlength: 100,
          value: building.name
        },
        onConfirm: function(value) {
          console.log("Renamed the building!");
          renameBuilding(building.id, value);
        },
        confirmText: "Rename"
      });
    }
  }
};
</script>

<style scoped>
/* #ecb9d2 */

#mytable {
  max-height: 65vh;
  overflow-y: auto;
}

#input {
  padding-bottom: 10px;
}

.three-dots {
  height: 24px;
  width: 24px;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
  width: 12px;
}

::-webkit-scrollbar:horizontal {
  height: 12px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  border: 2px solid #ffffff;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #ffffff;
}

.is-vertical-center {
  display: flex;
  align-items: center;
}
</style>

<style>
.table-wrapper {
  overflow-x: initial !important;
}

thead {
  /* visibility: hidden; */
  /* height: 0px; */
  position: fixed;
  /* margin-top: -30px; */
  bottom: -100px;
  right: -100px;
}

.th-wrap {
}

.b-table .table {
  border: 0px;
}

.table tr {
  color: #363636;
}

.table tr.is-selected {
  background-color: #e8eaed;
  color: #363636;
}

.table td,
.table th {
  border: 0px;
}

.tag:not(body) {
  background-color: transparent;
}

.table tr td span div div span div p {
  color: white;
}
.table tr.is-selected td span div div span div {
  color: #363636;
}
.table tr.is-selected td span div div span div p {
  color: #e8eaed;
}
.table tr td:hover span div div span div p {
  color: #363636;
}
.item-three-dots:hover {
  background-color: #8383832a;
  border-radius: 20px;
}

.buildings-table-label {
  color: #8e8e8e;
  font-weight: 600;
  font-size: 0.8rem;
  text-align: left;
  padding-left: 5px;
  padding-top: 18px;
}
</style>
